import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=1cd31a8e&scoped=true&"
import script from "./feedBack.js?vue&type=script&lang=js&"
export * from "./feedBack.js?vue&type=script&lang=js&"
import style0 from "./feedBack.css?vue&type=style&index=0&id=1cd31a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd31a8e",
  null
  
)

export default component.exports